import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  UUID: { input: string; output: string; }
}

/** Types of agent events */
export type AgentEventType =
  /** Agent was created */
  | 'CREATED'
  /** Agent was deleted */
  | 'DELETED'
  /** Agent was updated */
  | 'UPDATED';

export interface AgentPricingInfoInput {
  amountMonthly?: InputMaybe<Scalars['Float']['input']>;
  amountPerCall?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  pricingType: PricingType;
  tierId?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Review status for marketplace agents during the approval process.
 *
 * Tracks the moderation status of agents submitted to the marketplace.
 */
export type AgentReviewStatus =
  /** Agent has been approved and can be published to the marketplace */
  | 'APPROVED'
  /** Agent is awaiting review by marketplace moderators */
  | 'PENDING'
  /** Agent has been rejected and cannot be published without changes */
  | 'REJECTED';

export interface AgentSkillInput {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parametersSchema?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Status of a registered agent in the marketplace.
 *
 * Determines whether an agent is available for use by users.
 */
export type AgentStatus =
  /** Agent is active and available for use */
  | 'ACTIVE'
  /** Agent is inactive and not available for use */
  | 'INACTIVE';

/**
 * Status of a personal assistant.
 *
 * Determines the current state of a user's AI assistant.
 */
export type AssistantStatus =
  /** Assistant is active and ready to use */
  | 'ACTIVE'
  /** Assistant is inactive and not available */
  | 'INACTIVE'
  /** Assistant setup is pending completion */
  | 'SETUP_PENDING';

export interface ChatMessageConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * Input for creating a new personal assistant.
 *
 * Used when a user sets up their first AI assistant with
 * personalized name, backstory, and configuration.
 */
export interface CreateAssistantInput {
  /** Optional ID of an uploaded avatar image file for the assistant */
  avatarFileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Background story and personality description (1-2000 characters) that defines how the assistant behaves and responds */
  backstory: Scalars['String']['input'];
  /** Optional JSON object with assistant configuration settings and custom parameters */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Display name for the assistant (1-100 characters, e.g., 'My AI Helper') */
  name: Scalars['String']['input'];
}

/**
 * Input for creating a new CLI access token.
 *
 * Used when a user wants to generate a new token for
 * authenticating CLI tools and scripts.
 */
export interface CreateCliTokenInput {
  /** Optional description of the token's purpose (e.g., 'Development laptop', 'CI/CD pipeline') */
  description?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for creating a new conversation.
 *
 * Used when explicitly creating a new conversation with optional metadata.
 */
export interface CreateConversationInput {
  /** ID of the assistant for this conversation */
  assistantId: Scalars['UUID']['input'];
  /** Optional JSON metadata for the conversation */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional title for the conversation */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Input for handling system message actions. */
export interface HandleSystemMessageActionInput {
  /** Action to perform (confirm, dismiss, edit, view) */
  action: SystemMessageActionType;
  /** Optional data for the action (e.g., edited text for edit action) */
  actionData?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the system message to act upon */
  messageId: Scalars['ID']['input'];
  /** The resource ID being acted upon (e.g., learning ID for learning acknowledgments) */
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of resource (e.g., 'learning', 'proactive_action') */
  resourceType?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Role of the message sender in chat conversations.
 *
 * Identifies who sent a message in a conversation between users and AI assistants.
 */
export type MessageSenderRole =
  /** Message was sent by an AI agent or assistant */
  | 'AGENT'
  /** Message was sent by the system for notifications */
  | 'SYSTEM'
  /** Message was sent by a human user */
  | 'USER';

/**
 * Pricing model types for marketplace agents.
 *
 * Defines how users are charged for using marketplace agents.
 */
export type PricingType =
  /** Agent is free to use with no charges */
  | 'FREE'
  /** Agent has free tier with paid premium features */
  | 'FREEMIUM'
  /** Agent charges per API call or usage */
  | 'PER_CALL'
  /** Agent requires a monthly subscription fee */
  | 'SUBSCRIPTION';

export interface RegisterMarketplaceAgentInput {
  agentDefinitionId: Scalars['String']['input'];
  asyncQueueName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developerId: Scalars['String']['input'];
  endpointUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricingInfo?: InputMaybe<AgentPricingInfoInput>;
  skills: Array<AgentSkillInput>;
  version: Scalars['String']['input'];
}

export interface SendMessageFromPaInput {
  content: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
}

/** Actions that can be performed on system messages. */
export type SystemMessageActionType =
  /** Confirm the information (e.g., confirm a learning) */
  | 'CONFIRM'
  /** Dismiss/reject the information */
  | 'DISMISS'
  /** Edit the information */
  | 'EDIT'
  /** View more details */
  | 'VIEW';

/**
 * Input for filtering task results in queries.
 *
 * Allows filtering by status, agent IDs, and date ranges.
 */
export interface TaskResultFilter {
  /** Filter by results created after this date */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by results created before this date */
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by delivery status */
  delivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by PA agent ID */
  paAgentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by SA agent definition ID */
  saAgentDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by task result status */
  status?: InputMaybe<TaskResultStatus>;
}

/**
 * Status of an A2A task result.
 *
 * Represents the completion status of async tasks processed by specialized agents.
 */
export type TaskResultStatus =
  /** Task completed successfully */
  | 'COMPLETED'
  /** Task failed with error */
  | 'FAILED'
  /** Task timed out */
  | 'TIMEOUT';

/**
 * Input for updating an existing personal assistant.
 *
 * All fields are optional - only provided fields will be updated.
 * Used to modify assistant name, backstory, avatar, or configuration.
 */
export interface UpdateAssistantInput {
  /** New avatar image file ID, or null to remove current avatar */
  avatarFileId?: InputMaybe<Scalars['UUID']['input']>;
  /** New background story and personality description (1-2000 characters) */
  backstory?: InputMaybe<Scalars['String']['input']>;
  /** Updated JSON configuration object with assistant settings */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** New display name for the assistant (1-100 characters) */
  name?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for updating conversation metadata.
 *
 * All fields are optional - only provided fields will be updated.
 */
export interface UpdateConversationInput {
  /** Updated metadata for the conversation */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** New title for the conversation */
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateMarketplaceAgentInput {
  agentDefinitionId: Scalars['String']['input'];
  asyncQueueName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endpointUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingInfo?: InputMaybe<AgentPricingInfoInput>;
  skills?: InputMaybe<Array<AgentSkillInput>>;
  status?: InputMaybe<AgentStatus>;
  version?: InputMaybe<Scalars['String']['input']>;
}

/** Filter options for user's agents */
export interface UserAgentFilter {
  /** Filter by agent type (internal/external) */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by review status */
  reviewStatus?: InputMaybe<AgentReviewStatus>;
  /** Search by name or description */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by agent status */
  status?: InputMaybe<AgentStatus>;
}

/**
 * Input for updating user profile preferences and settings.
 *
 * Allows users to update their preferences JSON object
 * and timezone setting in a single operation.
 */
export interface UserProfilePreferencesInput {
  /** JSON object containing user preferences (theme, notifications, etc.) - will be merged with existing preferences */
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  /** IANA timezone identifier (e.g., 'America/New_York', 'Europe/London') */
  timezone?: InputMaybe<Scalars['String']['input']>;
}

/**
 * User roles for authorization and access control.
 *
 * Defines the permission level and capabilities of users within the platform.
 */
export type UserRole =
  /** Administrator with full platform access and management capabilities */
  | 'ADMIN'
  /** Developer with access to agent development and marketplace features */
  | 'DEVELOPER'
  /** Regular user with access to personal assistant and basic platform features */
  | 'USER';

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, clerkUserId: string, email: string, timezone?: string | null, preferences: Record<string, unknown>, isPaSetupComplete: boolean, createdAt: string, updatedAt: string } };

export type UserHasAssistantQueryVariables = Exact<{ [key: string]: never; }>;


export type UserHasAssistantQuery = { __typename?: 'Query', userHasAssistant: boolean };

export type MyAssistantQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAssistantQuery = { __typename?: 'Query', myAssistant?: { __typename?: 'Assistant', id: string, name: string, backstory: string, avatarFileId?: string | null, configuration?: Record<string, unknown> | null, createdAt: string, updatedAt: string } | null };

export type GetOrCreateConversationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrCreateConversationQuery = { __typename?: 'Query', getOrCreateConversation: { __typename?: 'Conversation', id: string, userId: string, assistantId: string, title?: string | null, status: string, createdAt: string, lastMessageAt?: string | null, messageCount: number } };

export type MyAgentsQueryVariables = Exact<{
  filter?: InputMaybe<UserAgentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyAgentsQuery = { __typename?: 'Query', myAgents: { __typename?: 'UserAgentConnection', totalCount: number, edges: Array<{ __typename?: 'UserAgentEdge', cursor: string, node: { __typename?: 'UserAgent', id: string, userID: string, agentDefinitionID: string, name: string, description?: string | null, instructions?: string | null, reviewStatus: AgentReviewStatus, status: AgentStatus, configuration?: Record<string, unknown> | null, version?: string | null, skills?: Array<string> | null, endpointURL?: string | null, asyncQueueName?: string | null, capabilityTags?: Array<string> | null, priority?: number | null, avgResponseTimeMs?: number | null, reviewedAt?: string | null, reviewedBy?: string | null, reviewNotes?: string | null, createdAt: string, updatedAt: string, isInternal: boolean, usageCount: number, successRate: number, lastInvokedAt?: string | null, pricingInfo?: { __typename?: 'AgentPricingInfo', pricingType: PricingType, currency?: string | null, amountMonthly?: number | null, amountPerCall?: number | null, features?: Array<string> | null, tierId?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type MyAgentStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAgentStatsQuery = { __typename?: 'Query', myAgentStats: { __typename?: 'UserAgentStats', totalAgents: number, activeAgents: number, pendingAgents: number, totalUsage: number, averageSuccessRate: number, monthToDateRevenue: number, revenueGrowthPercent: number } };

export type AgentUpdatesSubscriptionVariables = Exact<{
  userID: Scalars['String']['input'];
}>;


export type AgentUpdatesSubscription = { __typename?: 'Subscription', agentUpdates: { __typename?: 'UserAgent', id: string, userID: string, agentDefinitionID: string, name: string, description?: string | null, instructions?: string | null, reviewStatus: AgentReviewStatus, status: AgentStatus, configuration?: Record<string, unknown> | null, version?: string | null, skills?: Array<string> | null, endpointURL?: string | null, asyncQueueName?: string | null, capabilityTags?: Array<string> | null, priority?: number | null, avgResponseTimeMs?: number | null, reviewedAt?: string | null, reviewedBy?: string | null, reviewNotes?: string | null, createdAt: string, updatedAt: string, isInternal: boolean, usageCount: number, successRate: number, lastInvokedAt?: string | null, pricingInfo?: { __typename?: 'AgentPricingInfo', pricingType: PricingType, currency?: string | null, amountMonthly?: number | null, amountPerCall?: number | null, features?: Array<string> | null, tierId?: string | null } | null } };

export type AgentStatsUpdatesSubscriptionVariables = Exact<{
  userID: Scalars['String']['input'];
}>;


export type AgentStatsUpdatesSubscription = { __typename?: 'Subscription', agentStatsUpdates: { __typename?: 'UserAgentStats', totalAgents: number, activeAgents: number, pendingAgents: number, totalUsage: number, averageSuccessRate: number, monthToDateRevenue: number, revenueGrowthPercent: number } };


export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkUserId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"}},{"kind":"Field","name":{"kind":"Name","value":"isPaSetupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const UserHasAssistantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserHasAssistant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userHasAssistant"}}]}}]} as unknown as DocumentNode<UserHasAssistantQuery, UserHasAssistantQueryVariables>;
export const MyAssistantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyAssistant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myAssistant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"backstory"}},{"kind":"Field","name":{"kind":"Name","value":"avatarFileId"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<MyAssistantQuery, MyAssistantQueryVariables>;
export const GetOrCreateConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrCreateConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrCreateConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assistantId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageAt"}},{"kind":"Field","name":{"kind":"Name","value":"messageCount"}}]}}]}}]} as unknown as DocumentNode<GetOrCreateConversationQuery, GetOrCreateConversationQueryVariables>;
export const MyAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAgentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myAgents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"agentDefinitionID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"pricingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountMonthly"}},{"kind":"Field","name":{"kind":"Name","value":"amountPerCall"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"tierId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endpointURL"}},{"kind":"Field","name":{"kind":"Name","value":"asyncQueueName"}},{"kind":"Field","name":{"kind":"Name","value":"capabilityTags"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"avgResponseTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"reviewedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNotes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isInternal"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"successRate"}},{"kind":"Field","name":{"kind":"Name","value":"lastInvokedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MyAgentsQuery, MyAgentsQueryVariables>;
export const MyAgentStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyAgentStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myAgentStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAgents"}},{"kind":"Field","name":{"kind":"Name","value":"activeAgents"}},{"kind":"Field","name":{"kind":"Name","value":"pendingAgents"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsage"}},{"kind":"Field","name":{"kind":"Name","value":"averageSuccessRate"}},{"kind":"Field","name":{"kind":"Name","value":"monthToDateRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"revenueGrowthPercent"}}]}}]}}]} as unknown as DocumentNode<MyAgentStatsQuery, MyAgentStatsQueryVariables>;
export const AgentUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AgentUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"agentDefinitionID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"pricingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountMonthly"}},{"kind":"Field","name":{"kind":"Name","value":"amountPerCall"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"tierId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endpointURL"}},{"kind":"Field","name":{"kind":"Name","value":"asyncQueueName"}},{"kind":"Field","name":{"kind":"Name","value":"capabilityTags"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"avgResponseTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"reviewedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNotes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isInternal"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"successRate"}},{"kind":"Field","name":{"kind":"Name","value":"lastInvokedAt"}}]}}]}}]} as unknown as DocumentNode<AgentUpdatesSubscription, AgentUpdatesSubscriptionVariables>;
export const AgentStatsUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AgentStatsUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentStatsUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAgents"}},{"kind":"Field","name":{"kind":"Name","value":"activeAgents"}},{"kind":"Field","name":{"kind":"Name","value":"pendingAgents"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsage"}},{"kind":"Field","name":{"kind":"Name","value":"averageSuccessRate"}},{"kind":"Field","name":{"kind":"Name","value":"monthToDateRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"revenueGrowthPercent"}}]}}]}}]} as unknown as DocumentNode<AgentStatsUpdatesSubscription, AgentStatsUpdatesSubscriptionVariables>;